/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurvePoolLike128,
  ICurvePoolLike128Interface,
} from "../ICurvePoolLike128";

const _abi = [
  {
    inputs: [
      {
        internalType: "int128",
        name: "i",
        type: "int128",
      },
      {
        internalType: "int128",
        name: "j",
        type: "int128",
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minDy",
        type: "uint256",
      },
    ],
    name: "exchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int128",
        name: "i",
        type: "int128",
      },
      {
        internalType: "int128",
        name: "j",
        type: "int128",
      },
      {
        internalType: "uint256",
        name: "dx",
        type: "uint256",
      },
    ],
    name: "get_dy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurvePoolLike128__factory {
  static readonly abi = _abi;
  static createInterface(): ICurvePoolLike128Interface {
    return new utils.Interface(_abi) as ICurvePoolLike128Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurvePoolLike128 {
    return new Contract(address, _abi, signerOrProvider) as ICurvePoolLike128;
  }
}
